import { createAsyncThunk } from "@reduxjs/toolkit";
import { PreAuthState, PreAuthLoginProps, PreAuthData } from "./types";
import axios from "axios";

export const PreAuthLogin = createAsyncThunk(
  "pre-auth/login",
  async (props: PreAuthLoginProps) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/merchants/session/login_v2/step_1`,
        {
          email: props.email,
          password: props.password,
          device_model: "WEB",
          device_type: "WEB",
          device_id: 1,
        },
        {
          headers: {
            api_key: "Basic 15cb7ebf9-3dcc-h28s-b056-2522c1eed03e",
          },
        }
      );

      if (response && response.data) {
        return {
          data: {
            ...response.data?.data,
            isAuthenticated: false,
          } as PreAuthData,
          status: "success",
          error: null,
        } as PreAuthState;
      } else {
        return {
          data: "Wrong email or password",
          status: "error",
          error: null,
        } as unknown as PreAuthState;
      }
    } catch (err) {
      return {
        data: "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as PreAuthState;
    }
  }
);

export const PreAuthLogout = createAsyncThunk("auth/logout", async () => {
  return {
    data: "Logged out!",
    status: "error",
    error: null,
  } as unknown as PreAuthState;
});

export const PreAuthForgotPassword = createAsyncThunk(
  "auth/forgot-password",
  async (email: string) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/merchants/session/forgot_password`,
        {
          email: email,
        },
        {
          headers: {
            api_key: "Basic 15cb7ebf9-3dcc-h28s-b056-2522c1eed03e",
          },
        }
      );

      if (response && response.status === 200) {
        return {
          data: {
            vaidEmail: true,
          },
          status: "success",
          error: null,
        } as unknown as PreAuthState;
      }
    } catch (err) {
      return {
        data: "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as PreAuthState;
    }
  }
);

export const GetAccountList = createAsyncThunk(
  "auth/get-account-list",
  async (props: any) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/merchants/list?user_type=${props.user_type}`,
        {
          headers: {
            api_key: "Basic 15cb7ebf9-3dcc-h28s-b056-2522c1eed03e",
            token: props.token,
          },
        }
      );

      if (response && response.data) {
        return {
          accounts: response,
        };
      } else {
        return {
          status: "error",
          error: null,
        } as unknown as PreAuthState;
      }
    } catch (err) {
      return {
        data: "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as PreAuthState;
    }
  }
);

export const PreAuthLoginStep2 = createAsyncThunk(
  "auth/login_v2/step_2",
  async (props: any) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/merchants/session/login_v2/step_2`,
        {
          email: props.email,
          id: props.id,
          device_model: "WEB",
          device_type: "WEB",
          device_id: 1,
        },
        {
          headers: {
            api_key: "Basic 15cb7ebf9-3dcc-h28s-b056-2522c1eed03e",
          },
        }
      );

      if (response && response.data) {
        return {
          data: {
            ...response.data?.data,
            isAuthenticated: true,
          } as PreAuthData,
          status: "success",
          error: null,
        } as PreAuthState;
      } else {
        return {
          data: "Wrong email or password",
          status: "error",
          error: null,
        } as unknown as PreAuthState;
      }
    } catch (err) {
      return {
        data: "Something went wrong!",
        status: "error",
        error: err,
      } as unknown as PreAuthState;
    }
  }
);
